import { useContext, useEffect } from "react";

import MapContext from "../map/MapContext";

import olMap from "ol/Map";
import { ZoomSlider } from "ol/control";

/**
 * Component to register the OL ZoomSlide control on the Map
 * using the MapContext.
 * @component
 * @example
 * <Map center={center} zoom={zoom} projection={Epsg27700}>
 *   ...
 *   <Controls>
 *     <ZoomSlide />
 *   </Controls>
 * </Map>
 */
const ZoomSlide = () => {
  const map = useContext(MapContext) as olMap;

  useEffect(() => {
    if (!map) return () => {};

    const control = new ZoomSlider();
    map.addControl(control);

    return () => {
      if (!map) return;
      map.removeControl(control);
    };
  }, [map]);

  return null;
};

export default ZoomSlide;
